import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import type { Id } from "@convex/_generated/dataModel";
import { useLeague } from "@/features/leagues/hooks/useLeague";
import { DraftedPlayersTable } from "@/features/leagues/rosters/components/DraftedPlayersTable";
import { PageContainer } from "@/shared/layout/PageContainer";
import { PageHeader } from "@/shared/layout/PageHeader";
import { Skeleton } from "@/shared/ui/Skeleton";
import { useT } from "@/shared/i18n/LocaleContext";

export const Route = createFileRoute(
  "/_authenticated/leagues/$leagueId/players/all",
)({
  component: LeagueAllPlayersPage,
});

function LeagueAllPlayersPage() {
  const { leagueId } = Route.useParams();
  const t = useT();
  const data = useLeague(leagueId as Id<"leagues">);
  const players = useQuery(api.rosters.listLeagueDraftedPlayers, {
    leagueId: leagueId as Id<"leagues">,
  });

  if (data === undefined || players === undefined) {
    return (
      <PageContainer>
        <Skeleton className="h-12 w-2/3 mb-8" />
        <Skeleton className="h-96 w-full" />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHeader
        eyebrow={data.league.name}
        title={t("league.players.allPlayers.title")}
        subtitle={t("league.players.allPlayers.subtitle")}
      />
      <DraftedPlayersTable rows={players} leagueId={leagueId as Id<"leagues">} />
    </PageContainer>
  );
}
